const headList = [
  {
    headTitle: "氏名",
  },
  {
    headTitle: "加入日",
  },
  {
    headTitle: "退職（予定）日",
  },
  {
    headTitle: "ならない月",
  },
  {
    headTitle: "育休",
  },
];
// ならない月変換マップ
const monthMapping = {
  apr: "4",
  may: "5",
  jun: "6",
  jul: "7",
  aug: "8",
  sep: "9",
  oct: "10",
  nov: "11",
  dec: "12",
  jan: "1",
  feb: "2",
  mar: "3",
} as any;

export { headList, monthMapping };
